import BaseApiRequest from "./BaseApiRequest";
import { VAULT_MEMBER_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetVaultMemberRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(VAULT_MEMBER_URL);

  getBody = () => this.body;
}
